<template>
  <div class="tab_container">
    <!-- 基本物价信息 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        基本物价信息
        <el-button
          v-if="$route.query.operateType !== '查看'"
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('basePriceInfo')"
          >保存</el-button
        >
      </div>
    </div>
    <base-price-info ref="basePriceInfo" />
    <!-- 基本政策 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        基本政策
        <el-button
          v-if="$route.query.operateType !== '查看'"
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('basePolicy')"
          >保存</el-button
        >
      </div>
    </div>
    <base-policy ref="basePolicy" />
    <!-- 主要汽车品牌以及中国汽车品牌的生产销售模式 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        主要汽车品牌以及中国汽车品牌的生产销售模式
        <el-button
          v-if="$route.query.operateType !== '查看'"
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('productionSaleModel')"
          >保存</el-button
        >
      </div>
    </div>
    <production-sale-model ref="productionSaleModel" />
    <!-- 汽车消费金融环境变化 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        汽车消费金融环境变化
        <el-button
          v-if="$route.query.operateType !== '查看'"
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('financeEnvironmentChange')"
          >保存</el-button
        >
      </div>
    </div>
    <finance-environment-change ref="financeEnvironmentChange" />
  </div>
</template>

<script>
import BasePriceInfo from "./basePriceInfo";
import BasePolicy from "./basePolicy";
import ProductionSaleModel from "./productionSaleModel";
import FinanceEnvironmentChange from "./financeEnvironmentChange";
import { getIndustryInfoApi } from "@/api/saleTaskCollection";

export default {
  components: {
    BasePriceInfo,
    BasePolicy,
    ProductionSaleModel,
    FinanceEnvironmentChange
  },
  data() {
    return {};
  },
  created() {
    this.getIndustryInfo();
  },
  methods: {
    // 获取行业信息
    async getIndustryInfo() {
      try {
        let data = {};
        if (this.$route.query.areaName && this.$route.query.countryName) {
          const res = await getIndustryInfoApi({
            areaName: this.$route.query.areaName,
            countryName: this.$route.query.countryName
          });
          if (res.status == 0) {
            data = res.data || {};
          } else {
            this.$DonMessage.error(res.message);
          }
        }
        this.$refs.basePriceInfo.init(data.saleBasicPriceList);
        this.$refs.basePolicy.init(data.saleIndustryPolicy);
        this.$refs.productionSaleModel.init(data.saleProductionBrandList);
        this.$refs.financeEnvironmentChange.init(data.saleCarFinanceList);
      } catch (error) {}
    },
    // 保存
    handleSave(refField) {
      let submitData = {};
      if (refField !== "baseInfo") {
        if (!this.$route.query.baseInfoId) {
          this.$DonMessage.warning("请先保存基础信息")
          return;
        }
        submitData = {
          areaName: this.$route.query.areaName,
          countryName: this.$route.query.countryName
        };
      }
      this.$refs[refField].handleSave(submitData);
    }
  }
};
</script>

<style lang="scss" scoped>
.tab_container {
  padding-bottom: 20px;
  .hearder_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title_icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .second_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .title_btn {
    margin-left: 20px;
  }
}
</style>
